"use strict";

// jQuery読み込み
import $ from "jquery";
// fontawesome読み込み
import { config, dom, library } from "@fortawesome/fontawesome-svg-core";
import {
  faBars,
  faXmark,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

library.add(faBars, faXmark, faChevronRight);
dom.i2svg();

$(function () {
  // 100vwの調整
  function setVw() {
    let vw = $(window).width() / 100 + "px";
    $(":root").css("--vw", vw);
  }
  setVw();

  // // ヘッダーの高さ取得
  // function setHeaderHeight() {
  //   const header = $(".l-header");
  //   if (header.length > 0) {
  //     // 要素が存在するか確認
  //     let headerHeight = header.outerHeight(); // 高さを取得
  //     $(":root").css("--headerHeight", `${headerHeight}px`);
  //   } else {
  //     console.error("Header element not found: .l-header");
  //   }
  // }
  // setHeaderHeight();

  function setContentInnerWidth() {
    const contentInner = $(".l-content__inner"); // クラスセレクタに修正
    if (contentInner.length > 0) {
      // 要素が存在するか確認
      let contentInnerWidth = contentInner.outerWidth(); // 幅を取得
      $(":root").css("--contentInnerWidth", `${contentInnerWidth}px`);
    } else {
      console.error("Content inner element not found: .l-content__inner");
    }
  }
  setContentInnerWidth();

  // debounce関数の定義
  function debounce(func, wait) {
    let timeout;
    return function () {
      const context = this,
        args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(context, args);
      }, wait);
    };
  }

  const debouncedSetVw = debounce(setVw, 200);
  const debouncedSetContentInnerWidth = debounce(setContentInnerWidth, 200);

  $(window).on("resize", function () {
    debouncedSetVw();
    debouncedSetContentInnerWidth();
  });

  // ドロワーメニューのトグル実装
  $(".js-drawerBtn").on("click", function () {
    $(this).toggleClass("is-open");
    $(".js-drawerMenu").toggleClass("is-show");
    // $('body').toggleClass('body-no-scroll');
  });

  // 検索テーブルのトグル実装
  $(".js-toggleBtn").on("click", function () {
    $(this).toggleClass("is-open");
    $(".p-top-search__searchArea").toggleClass("is-open");
  });

  // スムーススクロール
  $('a[href^="#"]').click(function (e) {
    e.preventDefault();

    let speed = 1000;
    let href = $(this).attr("href");
    let target = $(href == "#" || href == "" ? "html" : href);
    let position = target.offset().top;

    $("html, body").animate(
      {
        scrollTop: position,
      },
      speed,
      "swing"
    );
  });

  // CTA 3000pxスクロールしたところで表示
  let fixCta = $(".js-fixCta");

  $(window).on("scroll", function () {
    if (window.innerWidth <= 767) {
      // 横幅が767px以下のとき
      if ($(this).scrollTop() > 3000) {
        fixCta.fadeIn();
      } else {
        fixCta.fadeOut();
      }
    }
  });

  let toTopBtn = $(".js-toTopBtn");

  $(window).on("scroll", function () {
    if ($(this).scrollTop() > 1000) {
      toTopBtn.fadeIn();
    } else {
      toTopBtn.fadeOut();
    }
  });
});
